import { Heading } from "@crunchyroll/cx-web-components";
import { FormattedMessage } from "react-intl";

import styles from "./CommentingSection.module.scss";
import CreateComment from "./CreateComment";
import CommentsWrapper from "./CommentsWrapper";
import { useContext } from "react";
import GuestbookContext from "../context/GuestbookContext";

const CommentingSection = ({}) => {
  const { totalComments } = useContext(GuestbookContext);

  return (
    <div className={`${styles.commentingSection} reset`}>
      {totalComments ? (
        <div className={styles.commentsHeader}>
          <Heading size="xxs" as="h5">
            <FormattedMessage
              id="comment.total_count"
              values={{ totalCount: totalComments }}
            />
          </Heading>
        </div>
      ) : null}
      <div className={styles.commentsWrapperNarrow}>
        <CreateComment className={styles.createComment} />
        <CommentsWrapper />
      </div>
    </div>
  );
};

export default CommentingSection;
